import { render, staticRenderFns } from "./StarredDeckCard.vue?vue&type=template&id=5ef9e712&scoped=true"
import script from "./StarredDeckCard.vue?vue&type=script&lang=js"
export * from "./StarredDeckCard.vue?vue&type=script&lang=js"
import style0 from "./StarredDeckCard.vue?vue&type=style&index=0&id=5ef9e712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef9e712",
  null
  
)

export default component.exports